export default "__VITE_ASSET__coxgR6tz__"